import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SaltService {
  generateSalt(length: number = 8): string {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let salt = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      salt += chars[randomIndex];
    }
    return salt;
  }
}
